import { useId } from 'react';
import { DocumentCheckIcon } from '@heroicons/react/24/outline';
import { WorkspaceSectionCard } from '../../../../components/workspaces/EntityWorkspacePrimitives';
import { Switch } from '../../../components/ui/switch';

interface TaxDeductibleControlProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function TaxDeductibleControl({ checked, onCheckedChange }: TaxDeductibleControlProps) {
  const labelId = useId();
  const descriptionId = useId();

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="min-w-0">
        <p id={labelId} className="text-sm font-medium text-ink-secondary">
          Tax Deductible
        </p>
        <p id={descriptionId} className="mt-0.5 text-xs text-ink-muted">
          {checked ? 'This payment is tax deductible' : 'This payment is not tax deductible'}
        </p>
      </div>
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        onMouseDown={(event) => event.preventDefault()}
        aria-labelledby={labelId}
        aria-describedby={descriptionId}
        className="focus:ring-0 focus-visible:ring-2 focus-visible:ring-sage"
      />
    </div>
  );
}

export default function TaxDeductibleCard({ checked, onCheckedChange }: TaxDeductibleControlProps) {
  return (
    <WorkspaceSectionCard
      title="Tax information"
      description="Control how this payment is treated for tax purposes."
      icon={DocumentCheckIcon}
    >
      <TaxDeductibleControl checked={checked} onCheckedChange={onCheckedChange} />
    </WorkspaceSectionCard>
  );
}
